import { inject } from 'mobx-react';
import React from 'react';
import { withRouter } from 'react-router-dom';
import { Dropdown, DropdownMenu, DropdownToggle } from 'reactstrap';

class DropdownGameNotice extends React.Component {
  constructor(props) {
    super(props);

    this.toggle = this.toggle.bind(this);
    this.innerClick = this.innerClick.bind(this);
    this.state = {
      dropdownOpen: false
    };
  }

  toggle() {
    this.setState(prevState => ({
      dropdownOpen: !prevState.dropdownOpen
    }));
  }

  innerClick() {
    if (this.props.clickMethod && typeof this.props.clickMethod === 'function') {
      this.props.clickMethod()
    }
  }

  render() {
    return (
      <Dropdown isOpen={this.state.dropdownOpen} toggle={this.toggle} className="fs-15 game_notice_badge d-center" >
        <DropdownToggle onClick={this.innerClick}>
          <div className={'w-100 h-100 d-center'}>!</div>
        </DropdownToggle>
        {
          this.props.rootStore.getGameNotice != null &&
          <DropdownMenu className="dropdown-menu dropdown-game-notice p-0" tag="ul">
            <img src={'/assets/image/close.png'} alt='' className='modal-close cursor-point' onClick={this.toggle} />
            <div className={'p-15 fs-14'} dangerouslySetInnerHTML={{ __html: this.props.rootStore.getGameNotice }} />
          </DropdownMenu>
        }
      </Dropdown>
    );
  }
}

export default withRouter(inject('rootStore')(DropdownGameNotice));
